import React from "react";
import logo from "../../assets/images/arrow-up-icon.svg";

const arrowLogo = props => <img className={props.className} src={logo} alt="arrow-up" />;

export default arrowLogo;
